import { labelChips } from '../../lib/event-labels.js'

const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- calendar-labels ---
let __fez_component_0;
{

__fez_component_0 = class {
  init() {
    this.state.items = []
    this.state.year = 0
    this.state.seq = 0
  }

  onMount() {
    this.load()
    this.on(window, 'focus', () => this.load(), { throttle: 2000 })
    this.subscribe('labels:change', () => this.load())
    this.subscribe('live:change', () => this.load())
    this.subscribe('live:calendar', () => this.load())
  }

  async load() {
    const seq = ++this.state.seq
    try {
      const data = await window.App.api('calendar/labels', {}, { silent: true })
      if (seq !== this.state.seq) return
      this.state.items = data.items
      this.state.year = data.year
    } catch (error) {
      if (seq === this.state.seq) window.Toast.error(error.message)
    }
  }

  beforeRender() {
    this.state.chips = labelChips(this.state.items, this.state.year)
  }

  CSS = `:fez {
display:block;flex:none;.ct{display:flex;align-items:center;gap:var(--space-2);padding:var(--space-2) var(--space-4);overflow-x:auto;border-bottom:1px solid var(--color-border);scrollbar-width:none}.ct-year{display:inline-flex;flex:none;align-items:center;gap:var(--space-1);color:var(--color-text-subtle);font-size:var(--text-xs);font-weight:var(--weight-semibold);font-variant-numeric:tabular-nums}.ct-chip{display:inline-flex;flex:none;align-items:center;gap:var(--space-2);height:26px;padding:0 var(--space-3);border:1px solid var(--color-border);border-radius:var(--radius-full);background:var(--color-bg-raised);color:var(--color-text);font-size:var(--text-sm);font-weight:var(--weight-medium);text-decoration:none;white-space:nowrap;&:hover{border-color:var(--tag);background:color-mix(in srgb,var(--tag) 10%,var(--color-bg-raised))}&:focus-visible{outline:2px solid var(--color-focus);outline-offset:1px}}.ct-dot{width:8px;height:8px;flex:none;border-radius:var(--radius-full);background:var(--tag)}.ct-hours{color:var(--color-text-muted);font-size:var(--text-xs);font-variant-numeric:tabular-nums} :mobile {.ct{padding:var(--space-2) var(--space-3)}}
}`

  HTML = `{#if state.chips.length}
<nav class="ct" aria-label="Labels, hours spent in {state.year}">
<span class="ct-year" title="Hours spent in {state.year}"><ui-icon name="tag" size="14"></ui-icon>{state.year}</span>
{#each state.chips as chip}
<a class="ct-chip" key={chip.name} href={chip.href} title={chip.title} style="--tag: var(--color-avatar-{chip.color})">
<span class="ct-dot"></span>
<span class="ct-name">{chip.name}</span>
<span class="ct-hours">{chip.hours}</span>
</a>
{/each}
</nav>
{/if}`
};
}

Fez('calendar-labels', __fez_component_0);

export default __fez_component_0;
